//https://api.openweathermap.org/data/2.5/weather?q=pune&appid=bb4b46827afe18c7984632dbf9687d61
import React, { useEffect, useState } from'react'
import './style.css'
import WeatherCard from './weatherCard';
const Temp=()=>{
    const [tempInfo,setTempInfo]=useState({});
    const [searchValue,setSearchValue]=useState("pune");
    const getWeatherInfo=async ()=>{
        try{
            let url=`https://api.openweathermap.org/data/2.5/weather?q=${searchValue}&units=metric&appid=bb4b46827afe18c7984632dbf9687d61`;
            const res=await fetch(url);
            const data=await res.json();
            // console.log(data);
            const {temp,humidity,pressure}=data.main;
            const {main:weathermood}=data.weather[0];
            const {name}=data;
            const {speed}=data.wind;
            const {country,sunset}=data.sys;
            setTempInfo({temp,humidity,pressure,weathermood,name,speed,country,sunset});
        }
        catch(e){
            console.log(e);
        }
    }
    useEffect(()=>{
        getWeatherInfo();
    },[])
    return (<>
    <div className='wrap'>
        <div className='search'>
            <input
                placeholder='search...'
                autoFocus
                id='search'
                className='searchTerm'
                value={searchValue}
                onChange={(e)=>setSearchValue(e.target.value)}
            />
            <button className='searchButton' type='button' onClick={getWeatherInfo}>Search</button>
        </div>
    </div>
    <WeatherCard tempInfo={tempInfo}/>
    </>)
}
export default Temp;
